import React, { useState, useEffect } from 'react';
import { Box, Divider, Typography, List, ListItem } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Timer from '../components/Timer';
import ToggleList from '../components/ToggleList';
import { fetchQuestionsHandler } from '../ResponseHandlers/fetchQuestionsHandler';
import FragenPage from './FragenPage';
import InProgress from '../components/InProgress';

const TestPage = () => {
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isTimeGo, setIsTimeGo] = useState(false);

    const handleConfirm = async (selectedOption) => {
        try {
            setLoading(true);
            const response = await fetchQuestionsHandler({
                selectedOption,
                usedPage: 'TestPage',
            });

            setQuestions(response);
        } catch (error) {
            console.error('Failed to fetch Test Questions:', error);
            setQuestions([]);
            setIsTimeGo(false);
        } finally {
            setLoading(false);
            setIsTimeGo(true);
        }
    };

    // Window scroll control (better to use useEffect)
    useEffect(() => {
        const mainElement = document.querySelector('#app-main'); // Locate the window where scroll works
        if (mainElement) {
            mainElement.scrollTo({ top: 0, behavior: 'auto' });
        } else {
            // Fallback to window if container not found
            window.scrollTo({ top: 0, behavior: 'auto' });
        }
    }, []);

    return (
        <Box sx={{ p: 3 }}>
            <Grid container spacing={2}>
                {/* Left: ToggleList */}
                <Grid xs={12} md={6}>
                    <ToggleList onConfirm={handleConfirm} />
                    {/* <ToggleList onConfirm={handleFetchQuestions} /> */}
                </Grid>
                {/* Right: Timer */}
                <Grid xs={12} md={6}>
                    <Timer timeGo={isTimeGo} />
                </Grid>
            </Grid>

            <Divider sx={{ my: 4 }} />

            {/* Questions Section */}
            <Box>
                <Typography variant="h5" sx={{ mb: 2 }}>
                    Fragen
                </Typography>
                {questions.length > 0 ? (
                    <FragenPage questions={questions} />
                ) : loading ? (
                    <InProgress />
                ) : (
                    <>
                        <Typography variant="body1" gutterBottom>
                            Die Prüfung besteht aus 33 Fragen, aufgeteilt in:
                        </Typography>
                        <List>
                            <ListItem>30 allgemeine Fragen</ListItem>
                            <ListItem>
                                3 Fragen zum Bundesland, in dem du wohnst
                            </ListItem>
                        </List>
                        <Typography variant="body1" gutterBottom>
                            Bitte wählen Sie ein Bundesland aus, um Prüfung zu
                            laden.
                        </Typography>
                    </>
                )}
            </Box>
        </Box>
    );
};

export default TestPage;
